import * as React from 'react'
import StyledDropDown from './DropDownMenu.style'
import ArrowDown from '../Icons/Button/ArrowDown'
import ArrowUp from '../Icons/Button/ArrowUp'
import colors, { Color } from '../../theme/colors'

type Props = {
  id: string,
  label: React.ReactElement | string,
  initialValue?: string,
  backgroundColor?: Color,
  onChange?: (string) => void,
  children: React.ReactElement | React.ReactElement[],
}

export const DropDownContext = React.createContext({})

/**
 * DropDown element
 * @param {object} props Component props
 * @param {string} props.id Element id
 * @param {string} props.label Element label
 * @param {string} props.initialValue Initial value
 * @param {string} props.backgroundColor Label text
 * @param {function} props.onChange Callback on change
 * @param {object} props.children The items of the dropdown. Links or MenuItems
 */

const DropDownMenu = ({ id, label, initialValue, backgroundColor, onChange, children }: Props) => {
  const [expanded, setExpanded] = React.useState(false)
  const [selectedMenuItemValue, setSelectedMenuItemValue] = React.useState(initialValue)
  const onSelect = (newValue: string) => {
    setSelectedMenuItemValue(oldValue => (oldValue !== newValue ? newValue : ''))
    /* istanbul ignore else */
    if (onChange) onChange(newValue)
  }

  return (
    <StyledDropDown
      id={id}
      className="select"
      backgroundColor={backgroundColor}
    >
      <div
        className="select__header"
        onClick={e => {
          setExpanded(oldValue => !oldValue)
          e.stopPropagation()
        }}
        onKeyUp={() => {}}
        role="button"
        tabIndex={0}
      >
        <span className="select__header-text">{label}</span>
        <span className="select__header-arrow">
          { expanded ? <ArrowUp /> : <ArrowDown /> }
        </span>
      </div>
      <div className={`select__content ${expanded ? 'select__content--expanded' : ''}`}>
        <DropDownContext.Provider
          value={{
            onSelect,
            selectedMenuItemValue
          }}
        >
          {children}
        </DropDownContext.Provider>
      </div>
    </StyledDropDown>
  )
}

DropDownMenu.defaultProps = {
  initialValue: '',
  backgroundColor: colors.Primary.White,
  onChange: () => {}
}

export default DropDownMenu
